import React, { useMemo } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";

// constants
import {
  CONTACT_EMAIL,
  SUPPORT_EMAIL,
} from "../../../components/Common/constant";
import LocaleStrings from "../../../languages";

const RegThanks = (props) => {
  const {
    // state props
    deviceSize,
    session,
    eventDetails,
    classRegistrationResult,

    // component props
    wrongId = false, // wrong link for class registration
    formExpired = false, // class registration not allowed
    regSeries = false, // class registration done
    regForm = false, // request done
    linkExpired = false, // class registration time over
    problem = false, // registration done, but some entrants not registered
    submitted = false, // registration request status 3, class already created
    eventMismatch = false, // if link event and fetched event mismatched
  } = props;

  let hostname = window.location.hostname;
  hostname = hostname.split(".")[0];
  let subdomain = hostname !== "localhost" ? hostname : session?.subdomain;
  let link = `https://${subdomain}.healthiestschools.co.nz/#/registration-form`;

  const leftMembers = !_.isEmpty(classRegistrationResult?.data?.problem_members)
    ? classRegistrationResult?.data?.problem_members
    : [];
  const doneMembers = useMemo(() => {
    const list = [];
    _.map(classRegistrationResult?.data?.payloadMembers, (memP) => {
      const found = _.find(
        classRegistrationResult?.data?.other_members,
        (memR) =>
          _.isEqual(memP?.firstname, memR?.firstname) &&
          _.isEqual(memP?.lastinitial, memR?.lastinitial)
      );
      if (found) list.push(memP);
    });
    return list;
  }, [classRegistrationResult]);
  const teacherDetails = classRegistrationResult?.data?.teacherDetails ?? {};

  const _renderTextWithHRefs = ({
    text = "",
    find = "",
    replace = "",
    type = "mail",
  }) => {
    const words = text.split(" ");
    return (
      <>
        <span>
          {_.map(words, (word, wordKey) => {
            if (word === find) {
              return (
                <a
                  key={`word_${wordKey}`}
                  className="mail-text-hover"
                  target="_blank"
                  href={type === "mail" ? `mailto: ${replace}` : replace}
                >
                  {replace}{" "}
                </a>
              );
            } else return <span key={`word_${wordKey}`}>{word} </span>;
          })}
        </span>
      </>
    );
  };

  const _renderLocalReachText = (text) => {
    const words = text.split(" ");
    return (
      <span>
        {_.map(words, (word, wordKey) => {
          if (_.includes(word, "BOLD")) {
            const local_word = _.split(word, "BOLD").pop();
            return <b key={`word_${wordKey}`}>{local_word} </b>;
          } else if (_.includes(word, "ITALIC")) {
            let local_word = _.split(word, "ITALIC").pop();
            local_word = _.split(local_word, "_").join(" ");
            return <i key={`word_${wordKey}`}>{local_word} </i>;
          } else return <span key={`word_${wordKey}`}>{word} </span>;
        })}
      </span>
    );
  };

  return (
    <>
      <div className="p-0 sm:p-2">
        <div
          className="bg-secondary p-2 sm:p-4"
          style={
            deviceSize.width > 640 ? { borderRadius: 13 } : { borderRadius: 0 }
          }
        >
          <div className="rounded-lg">
            <div className="rounded-lg lg:justify-center pl-3 text-center"></div>
            <div
              className="bg-secondary-2 p-12 rounded-lg text-gray-600"
              style={{ ...(regSeries || problem ? {} : { height: 300 }) }}
            >
              {eventMismatch ? (
                _renderTextWithHRefs({
                  text: LocaleStrings.registration_event_mismatch,
                  find: "#CONTACT_EMAIL#",
                  replace: CONTACT_EMAIL,
                  type: "mail",
                })
              ) : wrongId ? (
                _renderTextWithHRefs({
                  text: LocaleStrings.registration_wrongid,
                  find: "#CONTACT_EMAIL#",
                  replace: CONTACT_EMAIL,
                  type: "mail",
                })
              ) : formExpired ? (
                _renderTextWithHRefs({
                  text: LocaleStrings.registration_form_expired,
                  find: "#REDIRECT_LINK#",
                  replace: link,
                })
              ) : linkExpired ? (
                _renderTextWithHRefs({
                  text: LocaleStrings.registration_link_expired,
                  find: "#CONTACT_EMAIL#",
                  replace: CONTACT_EMAIL,
                  type: "mail",
                })
              ) : submitted ? (
                _renderLocalReachText(
                  LocaleStrings.registration_already_sumitted
                )
              ) : regForm ? (
                <article className="flex flex-col gap-4">
                  <p>
                    We have sent you an email to confirm we have received your
                    expression of interest. If you have not received it please
                    search for or check your SPAM folder for an email from{" "}
                    <span className="text-blue-500 underline">
                      {SUPPORT_EMAIL}
                    </span>{" "}
                    (and then mark as NOT SPAM if needed).
                  </p>

                  <p>
                    If we have places available for your class, you will also
                    receive an email containing a unique link to complete your
                    class entry. We will also text you to let you know the email
                    has been sent.
                  </p>
                </article>
              ) : regSeries || problem ? (
                <>
                  {problem ? (
                    !_.isEmpty(doneMembers) || !_.isEmpty(leftMembers) ? (
                      <p>
                        Your Class Registration is{" "}
                        <strong>almost complete</strong>. While creating your
                        desired team we had some issues creating the team with
                        the details of some entrants. Please get the details
                        from below. Contact Admin at{" "}
                        <a
                          className="mail-text-hover"
                          target="_blank"
                          href={`mailto: ${CONTACT_EMAIL}`}
                        >
                          {CONTACT_EMAIL}
                        </a>{" "}
                        for further assistance.
                      </p>
                    ) : (
                      <span className="">
                        {classRegistrationResult?.message}
                      </span>
                    )
                  ) : (
                    <div className="flex flex-col gap-4">
                      <p>
                        Thank you, your class team is now confirmed. Below are
                        the logins for your students, please copy and save these
                        (screenshot or paste into a document) to give out as
                        once you proceed the passwords will be encrypted for
                        security.{" "}
                      </p>

                      <p>
                        Once you have copied the login details please{" "}
                        <a
                          className="mail-text-hover"
                          target="_blank"
                          href={window.location.origin}
                        >
                          go to the event website
                        </a>{" "}
                        save it as a favourites site, edit your avatar then
                        watch the short video on how to enter data when the
                        event starts.
                      </p>
                    </div>
                  )}

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-6 md:px-12 mt-4 text-gray-700 font-bold">
                    {!_.isEmpty(teacherDetails) && (
                      <div className="col-span-2">
                        <table className="w-full">
                          <thead className="border-b-4 border-secondary-2">
                            <tr className="mt-1">
                              <td>Teacher Name</td>
                              <td>Username</td>
                              <td>Password</td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="mt-1 font-normal">
                              <td>{teacherDetails?.name}</td>
                              <td>{teacherDetails?.email}</td>
                              <td>{teacherDetails?.password}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    )}

                    {!_.isEmpty(doneMembers) && (
                      <div className={`col-span-${problem ? "1" : "2"}`}>
                        {problem && (
                          <div
                            className={`border-b${
                              problem ? "-4" : ""
                            } border-secondary-2`}
                          >
                            Successfully Registered
                          </div>
                        )}
                        <table className="w-full">
                          {!problem && (
                            <thead className="border-b border-secondary-2">
                              <tr className="">
                                <td>Student Name</td>
                                <td>Username</td>
                                <td>Password</td>
                              </tr>
                            </thead>
                          )}
                          <tbody>
                            {_.map(doneMembers, (stu, key) => {
                              return (
                                <tr
                                  key={`${stu?.password}${key}`}
                                  className="mt-1 font-normal"
                                >
                                  {problem ? (
                                    <td>
                                      {stu?.firstname}
                                      {stu?.lastinitial}
                                    </td>
                                  ) : (
                                    <>
                                      <td>{stu?.firstname}</td>
                                      <td>
                                        {stu?.firstname}
                                        {stu?.lastinitial}
                                      </td>
                                      <td>{stu?.password}</td>
                                    </>
                                  )}
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {!_.isEmpty(leftMembers) && (
                      <div className="col-span-1">
                        <div className="border-b-4 border-secondary-2">
                          Could not register
                        </div>
                        <table className="w-full">
                          <tbody>
                            {_.map(leftMembers, (stu, key) => {
                              return (
                                <tr
                                  key={`${stu?.firstname}${key}${stu?.lastinitial}`}
                                  className="mt-1 font-normal"
                                >
                                  <td>
                                    {stu?.firstname}
                                    {stu?.lastinitial}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    deviceSize: state.deviceSize,
    session: state.session,
    eventDetails: state.eventDetails,
    classRegistrationResult: state.classRegistrationResult,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RegThanks);
